export default defineNuxtPlugin((_nuxtApp) => {
  return {
    provide: {
      getOgImageUrl: (path: string) => {
        const base_url = useRequestURL()

        const og_path = `__og-image__/image/${path}/og.png`.replace(/\/+/g, '/')

        return `https://${base_url.host}/${og_path}`
      },
    },
  }
})
